import React, {useCallback, useEffect, useState} from 'react';
import {Outlet, useLocation, useNavigate} from 'react-router';
import * as http from '../../handlers/http';
import {ObscurlOutcome, Service} from '../../types/ObscurlOutcome';
import {useSession} from '../SessionContext';
import {initSessionRefresh, setNonce} from '../auth';
import LoadingPage from "../../components/pages/LoadingPage";
import {PAGES_PATHS} from "../../Entrypoint";
import {ApiError, ErrorCode} from "../../types/Error";
import {ErrorParam} from "../../components/pages/ErrorPage";

export default function ObscurlGate() {
	const navigate = useNavigate();
	const location = useLocation();
	const {setSession} = useSession();
	const [authorized, setAuthorized] = useState<boolean>(false);

	useEffect(() => {
		setNonce(null);
		http.post<void>('/web/auth/revoke')
				.then(() => {
					verifyObscurl();
				})
				.catch(() => {
					navigate(`/${PAGES_PATHS.ERROR}?${ErrorParam.KEY}=${ErrorCode.AUTHENTICATION_ERROR}`, {replace: true});
				});
	}, []);

	const verifyObscurl = useCallback((): void => {
		const params = new URLSearchParams(location.search);
		const obscurlKey = params.get('q');

		let url = '/web/auth/obscurl';
		if (obscurlKey !== null) {
			url += `?q=${encodeURIComponent(obscurlKey)}`;
		}

		http.post<ObscurlOutcome>(url)
				.then(res => {
					setNonce(res.nonce);

					window.history.replaceState({}, '', location.pathname);

					if (res.request.service === Service.CD_UPLOAD || res.request.service === Service.DICOMIZE) {
						console.log("%c ZEEROmed Upload web UI", "font-size: 1.3rem;color: #20a8d8");
						setSession({
							service: res.request.service,
							requestData: res.request.data,
						});
						setAuthorized(true);
						initSessionRefresh();
						navigate(res.request.service == Service.CD_UPLOAD ? PAGES_PATHS.CD_UPLOAD : PAGES_PATHS.DICOMIZE, {replace: true});
					} else {
						setSession(null);
						setNonce(null);
						navigate(`/${PAGES_PATHS.ERROR}?${ErrorParam.KEY}=${ErrorCode.SERVICE_NOT_FOUND}
							&${ErrorParam.REQUESTED_SERVICE}=${res.request.service}`, {replace: true});
					}
				})
				.catch((err: ApiError) => {
					setSession(null);
					setNonce(null);
					navigate(`/${PAGES_PATHS.ERROR}?${ErrorParam.KEY}=${ErrorCode.ACCESS_CODE_ERROR}&
						${ErrorParam.ACCESS_CODE_ERROR_CODE}=${err.code}`, {replace: true});
				});
	}, []);

	return (
			<React.Fragment>
				{authorized ? <Outlet/> : <LoadingPage/>}
			</React.Fragment>
	);
}
